import React from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as G2Logo } from 'Assets/svg/g2-logo-with-bg.svg';
import { ReactComponent as RightArrow } from 'Assets/svg/right-arrow.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import userDetail from 'Stores/userDetail';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';

const G2ReviewPopup = observer(() => {
  const updateLocalStorageData = () => {
    const previousData = Utils.getLocalStorage('g2');
    const { lastShown, count } = previousData;
    Utils.setLocalStorage('g2', {
      lastShown,
      count,
      reviewed: true,
    });
  userDetail.setShowG2Popup(false);
    Utils.mixpanelTrack(CONSTANTS.G2_EVENTS.G2_LINK_CLICKED, {});
  };

  return (
    userDetail.showG2Popup && (
      <div className="g2-review-popup">
        <div className="relative-wrap">
          <G2Logo className="g2-logo" />
          <CloseIcon
            className="close-icon"
            onClick={() => userDetail.setShowG2Popup(false)}
          />
          <div className="title">Hi {userDetail.userInfo.name},</div>
          <div className="message">
            Great start! Would you like an extra 20 free credits by reviewing us
            on G2?
          </div>
          <a
            onClick={updateLocalStorageData}
            href="https://www.g2.com/products/adapt-adapt/take_survey"
            target="_blank"
            rel="noopener noreferrer"
          >
            Yes, Take me to G2 <RightArrow className="arrow" />
          </a>
          <span className="italic-text">
            <i>*Contact support to avail credits</i>
          </span>
        </div>
      </div>
    )
  );
});

export default G2ReviewPopup;
